// extracted by mini-css-extract-plugin
export default {"form":"resetPassword_form__VuuT-","header":"resetPassword_header__J1kzK","closeButton":"resetPassword_closeButton__I7X1u","actionButtons":"resetPassword_actionButtons__GWgiN"};